'use strict';

angular.module('amexReconciliationApp')
  .service('ReallocateTransactionsRepository', function($http) {
    var self = this;

    self.reallocateTransactionAllocations = function(reallocations) {
      return $http.post('/api/v1/transactions/reallocate', reallocations);
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/ReallocateTransactionsRepository.js
// module id = 618
// module chunks = 0